<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <h2>Overview</h2>
</nav>

<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark text-white mb-3">
        <img
          src="/assets/img/module-feel-well-470x260.jpg"
          class="card-img-top card-img-top-fh img-mobile"
          alt="A contemplative woman"
        />
        <img
          src="/assets/img/module-feel-well-930x260.jpg"
          class="card-img-top card-img-top-fh img-desktop"
          alt="A contemplative woman"
        />
        <div class="card-body text-center">
          <h3 class="card-title card-title-lg">Feel Well For Surgery</h3>
          <p class="card-text">Welcome to Feel Well! The psychological wellbeing module that aims to help you prepare for surgery by managing your mood and stress levels.</p>
        </div>
      </div>
      <button
        class="btn btn-primary w-100"
        [routerLink]="['/modules', 'feel-well', 'tracker']"
      >
        Feel Well Tracker
      </button>
    </div>
    <div class="col-12" *ngIf="userData">
      <h4 class="text-center mt-4 mb-2">Module Task List</h4>

      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/modules', 'feel-well', 'resources']">
                <span class="circle-num">1</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"
                  >Welcome to Feel Well</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'feel-well', 'resources', 27]">
                <span class="circle-num">2</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">
                  Why it's important to Feel Well for surgery	
                 </span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'feel-well', 'resources', 28]">
                <span class="circle-num">3</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"> How to Feel Well for surgery	</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'feel-well', 'resources', 29]">
                <span class="circle-num">4</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">
                  How to control my breathing to Feel Well for surgery	</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'feel-well', 'resources', 30]">
                <span class="circle-num">5</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                    ></span>
                <span class="link-label">
                  How to record and monitor my Feel Well progress for surgery</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                    ></span>
              </a>
            </li>
            <li>
              <a  [routerLink]="['/modules', 'feel-well', 'tracker']">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'face-smile-relaxed']"></fa-icon
                ></span>
                <span class="link-label"
                  >Add Entries to the Feel Well tracker</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a   (click)="journalService.onShowJournal('feelWell')">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'book']"></fa-icon
                ></span>
                <span class="link-label"
                  >Feel Well Journal</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
